import styled from 'styled-components/macro';

import TableBase from '@components/common/core/Utils/Table';
import HeadingBase from '@components/common/core/DataDisplay/Heading';
import TextBase from '@components/common/core/DataDisplay/Text';
import BadgeBase from '@components/common/core/DataDisplay/Badge';
import CheckboxBase from '@components/common/core/Inputs/Checkbox';
import CustomPopoverBase from '@components/common/core/Utils/CustomPopover';

export const CustomPopover = styled(CustomPopoverBase)``;

export const CustomPopoverContent = styled(CustomPopoverBase.Content)`
  background-color: ${({ theme }) => theme.colors.black.light};
  padding: 16px 20px;
  border-radius: 5px;
  width: 100%;
  max-width: 269px;
  padding: 16px 20px;
  box-sizing: border-box;
`;

export const CustomPopoverArrow = styled(CustomPopover.Arrow)`
  fill: ${({ theme }) => theme.colors.black.light};
`;

export const DeleteSelectedMembersButton = styled.button`
  border: unset;
  padding: unset;
  background-color: unset;
  font-family: ${({ theme }) => theme.fonts.body};
  font-weight: 400;
  font-size: 0.875rem;
  line-height: 120%;
  color: ${({ theme }) => theme.colors.danger.light};
  display: flex;
  align-items: center;
  gap: 12px;
  transition: all 0.3s;
  cursor: pointer;

  &:hover {
    filter: brightness(1.1);
  }

  &:active {
    filter: brightness(0.9);
  }
`;

export const CheckboxWrapper = styled.div`
  width: fit-content;
  height: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  background-color: ${({ theme }) => theme.colors.gray[7]};
`;

export const Checkbox = styled(CheckboxBase)``;

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 16px;
`;

export const Header = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Heading = styled(HeadingBase)`
  color: ${({ theme }) => theme.colors.white.default};

  @media only screen and (max-width: 420px) {
    margin-right: 10px;
  }
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
`;

export const ButtonTrigger = styled(CustomPopoverBase.Trigger)`
  background-color: ${({ theme }) => theme.colors.gray[6]};
  border-radius: 5px;
  min-width: 102px;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  font-family: ${({ theme }) => theme.fonts.body};
  font-weight: 400;
  font-size: 0.875rem;
  line-height: 120%;
  color: #fff;
  transition: all 0.3s;
  cursor: pointer;

  &:hover {
    filter: brightness(1.1);
  }

  &:active {
    filter: brightness(0.9);
  }

  @media only screen and (max-width: 420px) {
    min-width: 80px;
  }

  @media only screen and (max-width: 370px) {
    gap: 8px;
  }
`;

export const InviteNewMemberButton = styled.button`
  width: 100%;
  min-width: 174px;
  height: 36px;
  border-radius: 5px;
  background-color: ${({ theme }) => theme.colors.gray[6]};
  display: flex;
  justify-content: center;
  align-items: center;
  border: unset;
  /* font-family: 'Poppins'; */
  font-family: 'Mukta';
  font-size: 0.875rem;
  font-weight: 500;
  color: #fff;
  cursor: pointer;
  transition: all 0.3s;

  &:hover {
    filter: brightness(1.1);
  }

  &:active {
    filter: brightness(0.9);
  }

  @media only screen and (max-width: 420px) {
    min-width: 145px;
  }

  @media only screen and (max-width: 370px) {
    min-width: 135px;
  }
`;

export const Table = styled(TableBase)`
  width: 100%;

  thead > tr > th:first-child {
    padding: 10px 0 10px 24px;
    width: 48px;
  }

  thead > tr > th:nth-child(2) {
    padding-left: 0;
  }

  tr td:first-child {
    padding: 10px 0 10px 24px;
  }

  tr td:nth-child(2) {
    padding-left: 0;
  }

  &::-webkit-scrollbar {
    height: 4px;
    width: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.colors.gray[1]};
    border-radius: 25px;
    margin-bottom: 4px;
  }
`;

export const MemberNameTableDataContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 6px 0;
`;

export const EmailTableDataContent = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 0;
`;

export const MemberName = styled(TextBase)``;

export const GroupName = styled(TextBase)`
  color: ${({ theme }) => theme.colors.gray[2]};
`;

export const Badge = styled(BadgeBase)`
  @media only screen and (max-width: 620px) {
    margin-left: 32px;
  }
`;
